import { z } from 'zod';

export const idnoSchema = z
  .string()
  .regex(/^\d{13,17}$/, 'IDNO trebuie să conțină 13-17 cifre')
  .brand<'Idno'>();
export type Idno = z.infer<typeof idnoSchema>;

export const idnpSchema = z
  .string()
  .regex(/^\d{13}$/, 'IDNP trebuie să conțină exact 13 cifre')
  .brand<'Idnp'>();
export type Idnp = z.infer<typeof idnpSchema>;

// The six Registrar types of UC50-15 (CF-15), spelled as the delivered data-model
// specification v1.1 spells `catalog_registrar_kind`. Catalog's column, the gateways
// and the screens all read this one list.
export const REGISTRAR_KINDS = [
  'MANUFACTURER',
  'IMPORTER',
  'WAREHOUSE',
  'PHARMACY',
  'IMSP',
  'PRIVATE_MEDICAL',
] as const;
export const registrarKindSchema = z.enum(REGISTRAR_KINDS);
export type RegistrarKind = z.infer<typeof registrarKindSchema>;

// NC-UC10-01 (CF-30, CF-08): a Registrar's code is its IDNO followed by 0000; its locations
// take 0001, 0002 and so on. UC21-05 makes it the organisation code MPass uses, so catalog
// stores it as a function of the IDNO and the gateway and the screens check against the same
// one.
export const REGISTRAR_CODE_SUFFIX = '0000';

export function registrarCodeOf(idno: string): string {
  return `${idno}${REGISTRAR_CODE_SUFFIX}`;
}

export const localeSchema = z.enum(['ro', 'ru', 'en']);
export type Locale = z.infer<typeof localeSchema>;

// Postgres types several identifiers as `uuid`, and a value that is not one is
// refused by the column with an error that names no field — it reaches the log as
// `invalid input syntax for type uuid: "filiala-3"` and the caller as a bare 500.
// The gateways refuse it first, so the caller is told which field is wrong.
//
// Version-agnostic on purpose: `uuid` accepts any version, and the point of the
// check is to refuse exactly what the column would refuse and nothing more.
// Over-constraining this has already cost an outage — `@IsUUID` on `registrarId`
// (an IDNO, never a uuid) rejected every real selector the bff sends, and a
// Registrar administrator could not list their own credentials at all.
export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
  return typeof value === 'string' && UUID_PATTERN.test(value);
}
